export default "__VITE_ASSET__6jyXHGiG__"